'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import NavBar from './NavBar';
import { AUTH_NO_NAVBAR_PATHS } from '../../utils/authRoutes';

export default function NavInvisibility({
	ndcHubUrl,
	hasActivePaidNdcAccess,
}: {
	ndcHubUrl?: string;
	hasActivePaidNdcAccess?: boolean;
}) {
	const pathname = usePathname();

	const hideNavbar = AUTH_NO_NAVBAR_PATHS.includes(pathname as (typeof AUTH_NO_NAVBAR_PATHS)[number]);

	if (hideNavbar) {
		return null;
	}

	return <NavBar ndcHubUrl={ndcHubUrl} hasActivePaidNdcAccess={hasActivePaidNdcAccess} />;
}
